//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { ErrorInfo, ReactElement } from 'react'

interface ErrorProps {
  // using `interface` is also ok
  children: any
}
interface ErrorState {
  hasError: boolean // like this
}

export class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  constructor(props: ErrorProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): ErrorState {
    // Update state so the next render will show the fallback UI.
    console.error(error)
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  render(): ReactElement {
    if (this.state.hasError) {
      if (window.location.href !== '/') {
        window.location.href = '/'
      }
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>
    }

    return this.props.children
  }
}
